import { useId } from 'react';

export interface SwitchProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  /** Libellés d'état affichés à côté de l'interrupteur (l'état n'est jamais porté par la couleur seule). */
  onLabel?: string;
  offLabel?: string;
}

export function Switch({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  id,
  onLabel = 'Activé',
  offLabel = 'Désactivé',
}: SwitchProps) {
  const generated = useId();
  const controlId = id ?? generated;
  const descriptionId = `${controlId}-description`;
  return (
    <div className="av-switch-field">
      <div className="av-switch-field__text">
        <label htmlFor={controlId} className="av-switch-field__label">
          {label}
        </label>
        {description ? (
          <p id={descriptionId} className="av-switch-field__description">
            {description}
          </p>
        ) : null}
      </div>
      <div className="av-switch-field__control">
        <span className="av-switch-field__state" aria-hidden="true">
          {checked ? onLabel : offLabel}
        </span>
        <button
          id={controlId}
          type="button"
          role="switch"
          aria-checked={checked}
          aria-describedby={description ? descriptionId : undefined}
          disabled={disabled}
          className="av-switch"
          onClick={() => {
            onChange(!checked);
          }}
        >
          <span className="av-switch__thumb" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
